import { BOARD_IMAGE_COPY } from "@/api/apiEndpoints";
import { canv } from "@/canv/global";

type ApiBoardImageCopyArgs = {
    imagesToCopy: Array<{ sourcePath: string }>;
    info: {
        sourceBoardUid: string;
        sourceBoardAccessToken?: string;
        targetBoardUid: string;
        targetBoardAccessToken?: string;
    };
};
type ApiBoardImageCopyResponse = {
    data: Array<{
        path?: string; // может быть пустым, если не скопировалось
        sourcePath: string;
    }>;
};

const BATCH_SIZE = 10;

export const ApiBoardImageCopy = async ({
    imagesToCopy,
    info,
}: ApiBoardImageCopyArgs): Promise<ApiBoardImageCopyResponse> => {
    const url = `${canv.host}${BOARD_IMAGE_COPY}`;

    const fetchBatch = async (
        batch: ApiBoardImageCopyArgs["imagesToCopy"],
    ): Promise<ApiBoardImageCopyResponse> => {
        const result = await fetch(url, {
            method: "POST",
            body: JSON.stringify({
                data: batch,
                sourceBoardUid: info.sourceBoardUid,
                sourceBoardAccessToken: info.sourceBoardAccessToken,
                targetBoardUid: info.targetBoardUid,
                targetBoardAccessToken: info.targetBoardAccessToken,
            }),
        });

        const json = await result.json();

        if (!result.ok) {
            if (json?.message) {
                throw new Error(json.message);
            }
            throw new Error("Не удалось скопировать изображения, попробуйте еще раз");
        }

        return json;
    };

    const data: ApiBoardImageCopyResponse["data"] = [];

    for (let i = 0; i < imagesToCopy.length; i += BATCH_SIZE) {
        const batch = imagesToCopy.slice(i, i + BATCH_SIZE);
        try {
            const response = await fetchBatch(batch);
            data.push(...response.data);
        } catch {
            // Пропускаем упавший батч и продолжаем обрабатывать следующие
        }
    }

    return { data };
};
